import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'galleries',
            name: 'gallery',
            class: 'Modules\\Site\\Entities\\Gallery'
        }
    }
}